<template>
  <div class="panel-admin-body">
    <div class="d-flex title">
      <div class="pb-1 button-center">
        <modal-link modal-id="How to Use" :content-list="pageContent" :image-size="'large'"></modal-link>Ranks
        <smart-center-link page="Moats" location="Header" />
      </div>
      <div class="ml-auto">
        <i v-show="this.$root.getShowMenuIcon() && this.$root.getShowHeaderMenu()"
          class="fa fa-window-minimize pl-1 pr-1" aria-hidden="true" @click="toggleHeaderMenu()"></i>
        <i v-show="this.$root.getShowMenuIcon() && !this.$root.getShowHeaderMenu()"
          class="fa fa-window-maximize pl-1 pr-1" aria-hidden="true" @click="toggleHeaderMenu()"></i>
      </div>
    </div>
    <saved-card-menu :entry-client-object="clientObject" :original-saved-cards="clientChartsBySurvey" set-type="survey" view-type="menu"></saved-card-menu>
    <div class="chart-app">
      <chart-criteria ref="chartCriteria" display-type-modal-name="Ranks" showUseTTMAsStartDate="true" :show-equal-weight="false" :use-chart-type-card="true" :content-list="pageContent" :is-comparative="false" 
      :show-include-organization-selected-in-group-ranks="true"
      @reset-client-chart="resetClientChart">
      </chart-criteria>
      <div class="row no-gutters">
        <div class="col">
          <div id="chartDislayCard">
            <div id="performance_dashboard">
              <div id="chart-filters" class="row">
                <chart-criteria-results ref="chartCriteriaResults" v-bind:criteria-results-list="criteriaResultsList"
                  v-show="!generatingChart && displayChartCriteriaResults"
                  v-bind:criteria-results-company-list="criteriaResultsCompanyList"></chart-criteria-results>
              </div>
              <chart-display-skeleton v-show="generatingChart"/>
              <MoneyballStickRank v-show="isMoneyballStickRank && !generatingChart" :input-data="moneyballStickRankData" :content-list="pageContent"></MoneyballStickRank>
              <BaseRank
                v-show="!generatingChart"
                :input-data="baseRankData"
                :input-data-for-competitors="baseRankDataForCompetitors"
                :content-list="pageContent"
                @set-chart-type-title="setChartTypeTitle"
              />
              <div v-show="getDisplayView() && !generatingChart" class="w-100 pt-2">
                <div class="chart-segment-options">
                  <a href="#" v-show="!displayRanksChartOptions" @click.prevent="toggleRanksChartOptions">Show Chart Options<i class="fa fa-chevron-down ml-1"></i></a>
                  <a href="#" v-show="displayRanksChartOptions" @click.prevent="toggleRanksChartOptions">Hide Chart Options<i class="fa fa-chevron-up ml-1"></i></a>
                </div>
              </div>
              <ranks-chart-criteria
                ref="ranksNeedsMetricsCriteria"
                v-show="getDisplayView() && displayRanksChartOptions && !generatingChart"
                :primary-axis-options="ranksNeedsMetricsPrimaryAxisOptions"
                :secondary-axis-options="ranksNeedsMetricsSecondaryAxisOptions"
                :selected-primary-axis="selectedRanksNeedsMetricsPrimaryAxis"
                :selected-secondary-axis="selectedRanksNeedsMetricsSecondaryAxis"
                :disabled="generatingChart"
                :can-save="displayRanksNeedsMetricsChart"
                @update-primary-axis="setRanksNeedsMetricsPrimaryAxis"
                @update-secondary-axis="setRanksNeedsMetricsSecondaryAxis"
                @draw="drawRanksNeedsMetricsChart"
                @save-card="saveRanksNeedsMetricsCard"
              />
              <ranks-chart-for-needs-and-metrics
                ref="ranksNeedsMetricsChart"
                v-if="displayRanksNeedsMetricsChart && !generatingChart"
                e-chart-id="ranks-needs-metrics-chart"
                e-chart-mini-id="ranks-needs-metrics-mini"
                modal-id="ranks-needs-metrics-chart-modal"
                input-report-type-name="Chart - Ranks Needs and Metrics"
                :input-client-chart="clientChart"
                :is-saved-card="clientChart.clientChartId != 0"
                :v-axis-for-performance="vAxisForPerformance"
                :v-axis-for-metric="vAxisForMetric"
                :content-list="pageContent"
                :chart-type-title="chartTypeTitle"
                @save-criteria="handleRanksNeedsMetricsCriteria"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="overlay d-none">
      <img class="overlay-inner d-none" src="../../assets/img/overlap.png"  style="width: 50%"/>
    </div>
    <div v-for="(pageContent, idxPageContent) in pageContent" v-bind:key="idxPageContent">
      <modal :modal-id="pageContent.title" :modal-title="pageContent.title" :modal-content="pageContent.contentText" />
    </div>
    <vue-modal ref="save-chart-confirmation" name="save-chart-confirmation" :width="350" :height="200">
      <save-chart :chart-title="this.chart.title" :initial-client-chart="this.clientChart" @save="updateClientCharts" @closeModal="closeModal('save-chart-confirmation')">
      </save-chart>
    </vue-modal>
    <vue-modal ref="auto-create-groups-of-tiers" name="auto-create-groups-of-tiers" :width="350" :height="250">
      <auto-create-groups :base-group-name="baseGroupName" :survey-group-by-tier-list="surveyGroupByTierList"
        @save="closeAutoGenerate" @closeModal="closeModal('auto-create-groups-of-tiers')"></auto-create-groups>
    </vue-modal>
  </div>


</template>
<script>

import ChartCompanyMixins from "../../mixins/ChartCompanyMixins.vue";
import ChartDisplaySkeleton from "../../components/skeleton/ChartDisplaySkeleton.vue";
import SaveChart from "../../components/chart/SaveChart.vue";
import AutoCreateGroups from "../../components/chart/AutoCreateGroups.vue";
import RanksChartCriteria from "../../components/chart/RanksChartCriteria.vue";
import MoneyballStickRank from "./type/MoneyballStickRank.vue";
import BaseRank from "./type/BaseRank.vue";
import RanksChartForNeedsAndMetrics from "../echarts/RanksChartForNeedsAndMetrics.vue";
import ChartService from "../../services/chart.service";
import ErrorService from "../../services/error.service";
import AdminService from "../../services/admin.service";
import ClientService from "../../services/client.service";

export default {
  name: "Ranks",
  mixins: [ChartCompanyMixins],
  components: {
    SaveChart,
    AutoCreateGroups,
    RanksChartCriteria,
    MoneyballStickRank,
    BaseRank,
    RanksChartForNeedsAndMetrics,
    ChartDisplaySkeleton
  },
  data() {
    return {
      title: "Ranks",
      pageNumber: 4,
      
      chartData: [],
      baseRankData: {},
      baseRankDataForCompetitors: {},
      moneyballStickRankData: {},
      surveyGroupByTierList: [],
      baseGroupName: "",
      isMoneyballStickRank: false,
      chartWidth: "",
      ranksNeedsMetricsPrimaryAxisOptions: [],
      ranksNeedsMetricsSecondaryAxisOptions: [],
      selectedRanksNeedsMetricsPrimaryAxis: "",
      selectedRanksNeedsMetricsSecondaryAxis: "",
      ranksNeedsMetricsSourceData: {},
      ranksNeedsMetricsChartData: {},
      displayRanksNeedsMetricsChart: false,
      displayRanksChartOptions: true,
      vAxisForPerformance: [],
      vAxisForMetric: [],
      chartTypeTitle: "",
      
    };
  },
  methods: {
    setChartTypeTitle(chartTypeTitle) {
      this.chartTypeTitle = chartTypeTitle;
    },
    closeModal(name) {
      if(this.$refs[name] != null) {
        this.$refs[name].visible = false;
      }
    },
    closeAutoGenerate: function (value, message) {
      AdminService.displaySuccessMessage({ text: message });
      this.$refs['auto-create-groups-of-tiers'].visible = false;
    },
    toggleRanksChartOptions() {
      this.displayRanksChartOptions = !this.displayRanksChartOptions;
    },
    displayMainChart() {
      this.clearRanksNeedsMetricsChart();
      return ChartCompanyMixins.methods.displayMainChart.call(this);
    },
    clearRanksNeedsMetricsChart() {
      this.ranksNeedsMetricsChartData = {};
      if (typeof this.$refs.ranksNeedsMetricsChart != "undefined" && this.$refs.ranksNeedsMetricsChart != null) {
        this.$refs.ranksNeedsMetricsChart.clearChart();
      }
      this.displayRanksNeedsMetricsChart = false;
    },
    getOptionList(optionList) {
      if (typeof optionList == "undefined" || optionList == null) {
        return [];
      }
      return optionList.map(option => {
        return {
          value: String(option.value),
          name: option.name,
          label: option.label
        };
      });
    },
    updateRanksNeedsMetricsOptions() {
      let chartCriteria = this.$refs.chartCriteria.$data;
      this.ranksNeedsMetricsPrimaryAxisOptions = this.getOptionList(chartCriteria.showNeeds);
      this.ranksNeedsMetricsSecondaryAxisOptions = this.getOptionList(chartCriteria.showMetricGroups);
      if (this.ranksNeedsMetricsPrimaryAxisOptions.find(option => option.value == this.selectedRanksNeedsMetricsPrimaryAxis) == null) {
        this.selectedRanksNeedsMetricsPrimaryAxis = this.ranksNeedsMetricsPrimaryAxisOptions.length > 0 ? this.ranksNeedsMetricsPrimaryAxisOptions[0].value : "";
      }
      if (this.ranksNeedsMetricsSecondaryAxisOptions.find(option => option.value == this.selectedRanksNeedsMetricsSecondaryAxis) == null) {
        this.selectedRanksNeedsMetricsSecondaryAxis = "";
      }
    },
    setRanksNeedsMetricsPrimaryAxis(value) {
      this.selectedRanksNeedsMetricsPrimaryAxis = value;
    },
    setRanksNeedsMetricsSecondaryAxis(value) {
      this.selectedRanksNeedsMetricsSecondaryAxis = value;
    },
    getSavedRanksNeedsMetricsAxis(axisName) {
      if (typeof this.clientChart == "undefined" || typeof this.clientChart.criteria == "undefined" || this.clientChart.criteria == "") {
        return "";
      }
      let params = new URLSearchParams(this.clientChart.criteria);
      return params.get(axisName) || "";
    },
    getColumnValue(column) {
      if (typeof column == "undefined" || column == null) {
        return "";
      }
      return String(column.value || column.id || column.name || column.label || "");
    },
    getColumnName(column) {
      if (typeof column == "undefined" || column == null) {
        return "";
      }
      return String(column.label || column.name || column.id || column.value || "");
    },
    normalizeColumnKey(value) {
      return String(value || "").toLowerCase().replace(/[^a-z0-9]/g, "");
    },
    findColumnIndex(columns, option) {
      let optionKeys = [
        this.normalizeColumnKey(option.value),
        this.normalizeColumnKey(option.name),
        this.normalizeColumnKey(option.label)
      ];
      for (let index = 0; index < columns.length; index++) {
        let columnKeys = [
          this.normalizeColumnKey(this.getColumnValue(columns[index])),
          this.normalizeColumnKey(this.getColumnName(columns[index]))
        ];
        if (columnKeys.some(columnKey => optionKeys.includes(columnKey))) {
          return index;
        }
      }
      return -1;
    },
    getRowCellValue(row, index) {
      if (typeof row.c != "undefined") {
        let cell = row.c[index];
        return typeof cell != "undefined" && cell != null ? cell.v : null;
      }
      if (Array.isArray(row)) {
        let cell = row[index];
        return typeof cell == "object" && cell != null && Object.prototype.hasOwnProperty.call(cell, "data") ? cell.data : cell;
      }
      return null;
    },
    getNameColumnIndex(columns) {
      let preferredNames = ["organization", "survey", "competitor", "company", "name"];
      for (let index = 0; index < columns.length; index++) {
        if (preferredNames.includes(this.normalizeColumnKey(this.getColumnName(columns[index])))) {
          return index;
        }
      }
      return columns.length > 1 ? 1 : 0;
    },
    getTierColumnIndex(columns) {
      for (let index = 0; index < columns.length; index++) {
        if (this.normalizeColumnKey(this.getColumnName(columns[index])) == "tier") {
          return index;
        }
      }
      return -1;
    },
    getNumericValue(value) {
      if (value === null || typeof value == "undefined" || value === "") {
        return null;
      }
      let numericValue = Number(String(value).replace(/[^0-9.-]/g, ""));
      return isNaN(numericValue) ? null : numericValue;
    },
    getAverage(values) {
      let numericValues = values.filter(value => value !== null && !isNaN(value));
      if (numericValues.length == 0) {
        return null;
      }
      return numericValues.reduce((total, value) => total + Number(value), 0) / numericValues.length;
    },
    getTierBoundaryIndexes(tiers, numberOfTiers) {
      const validTierValues = ["1W", "2W", "3W", "4W", "5W"];
      const requiredBoundaryCount = Math.max(0, Number(numberOfTiers) - 1);
      let boundaries = [];
      let previousTier = null;
      for (let index = 0; index < tiers.length && boundaries.length < requiredBoundaryCount; index++) {
        let tier = String(tiers[index] || "").trim().toUpperCase();
        if (!validTierValues.includes(tier)) {
          continue;
        }
        if (previousTier != null && tier != previousTier) {
          boundaries.push(index);
        }
        previousTier = tier;
      }
      return boundaries;
    },
    buildRanksNeedsMetricsChartData() {
      let primaryAxis = this.ranksNeedsMetricsPrimaryAxisOptions.find(option => option.value == this.selectedRanksNeedsMetricsPrimaryAxis);
      let secondaryAxis = this.ranksNeedsMetricsSecondaryAxisOptions.find(option => option.value == this.selectedRanksNeedsMetricsSecondaryAxis);
      if (typeof primaryAxis == "undefined" || typeof this.ranksNeedsMetricsSourceData.cols == "undefined") {
        return {};
      }
      let columns = this.ranksNeedsMetricsSourceData.cols;
      let rows = this.ranksNeedsMetricsSourceData.rows || [];
      let primaryColumnIndex = this.findColumnIndex(columns, primaryAxis);
      let secondaryColumnIndex = typeof secondaryAxis == "undefined" ? -1 : this.findColumnIndex(columns, secondaryAxis);
      if (primaryColumnIndex == -1) {
        return {};
      }
      let nameColumnIndex = this.getNameColumnIndex(columns);
      let tierColumnIndex = this.getTierColumnIndex(columns);
      let numberOfTiers = this.$refs.chartCriteria.$data.ranking_tier;
      let otherData = this.baseRankData["otherData"] || {};
      let respondentCounts = otherData.respondentCounts || {};
      let names = [];
      let tiers = [];
      let needValues = [];
      let metricValues = [];
      for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
        let name = this.getRowCellValue(rows[rowIndex], nameColumnIndex);
        let needValue = this.getNumericValue(this.getRowCellValue(rows[rowIndex], primaryColumnIndex));
        if (name != null && needValue != null) {
          names.push(String(name));
          needValues.push(needValue);
          tiers.push(tierColumnIndex == -1 ? "" : this.getRowCellValue(rows[rowIndex], tierColumnIndex));
          if (secondaryColumnIndex != -1) {
            metricValues.push(this.getNumericValue(this.getRowCellValue(rows[rowIndex], secondaryColumnIndex)));
          }
        }
      }
      let chartData = {
        names: names,
        tierBoundaryIndexes: this.getTierBoundaryIndexes(tiers, numberOfTiers),
        needAxis: primaryAxis,
        metricAxis: secondaryColumnIndex == -1 ? null : secondaryAxis,
        needValues: needValues,
        metricValues: metricValues,
        respondentCounts: JSON.parse(JSON.stringify(respondentCounts)),
        needAverage: this.getAverage(needValues),
        metricAverage: this.getAverage(metricValues),
        needAverageColor: ClientService.getClientColor(this.clientId),
        metricAverageColor: this.clientSettings.metricsColor || "#28945D"
      };
      return chartData;
    },
    drawRanksNeedsMetricsChart() {
      this.ranksNeedsMetricsChartData = this.buildRanksNeedsMetricsChartData();
      this.displayRanksNeedsMetricsChart = typeof this.ranksNeedsMetricsChartData.names != "undefined" && this.ranksNeedsMetricsChartData.names.length > 0;
      if (this.displayRanksNeedsMetricsChart) {
        this.$nextTick(() => {
          this.$refs.ranksNeedsMetricsChart.processChart(true, this.ranksNeedsMetricsChartData, this.eChartCriteria);
        });
      } else {
        AdminService.displayErrorMessage({ text: "The selected axis is not available in the Ranks response." });
      }
    },
    handleRanksNeedsMetricsCriteria() {
      let params = new URLSearchParams();
      params.set("primaryAxis", this.selectedRanksNeedsMetricsPrimaryAxis);
      params.set("secondaryAxis", this.selectedRanksNeedsMetricsSecondaryAxis);
      if (this.$refs.chartCriteria && this.$refs.chartCriteria.eChartCriteria) {
        const chartCriteria = this.$refs.chartCriteria.eChartCriteria;
        ["displayNumberOfResponses", "showTooltip"].forEach(criteriaName => {
          if (Object.prototype.hasOwnProperty.call(chartCriteria, criteriaName)) {
            params.set(criteriaName, chartCriteria[criteriaName]);
          }
        });
      }
      const existingParams = new URLSearchParams(this.clientChart.criteria);
      const newParams = new URLSearchParams(params);
      for (const [key, value] of newParams.entries()) {
          existingParams.set(key, value); // replaces if already exists
      }
      this.clientChart.criteria = existingParams.toString();
    },
    saveRanksNeedsMetricsCard() {
      this.handleRanksNeedsMetricsCriteria();
      const saveChartButton = this.$refs.chartCriteria.$el.querySelector("#save_chart");
      if (saveChartButton != null) {
        saveChartButton.click();
      }
    },
    getChartCriteriaParams(chart, chartCriteria) {
      let params = ChartCompanyMixins.methods.getChartCriteriaParams.call(this, chart, chartCriteria);
      if (params.get("display_type") == "ranks-needs-and-metrics") {
        params.set("display_type", "moat-rank");
      }
      return params;
    },
    async displayChartCallback(response) {
      try {
        this.$root.processServerResponse();
        this.generatingChart = false;

        this.chartData = response.data;
        this.baseRankData = JSON.parse(JSON.stringify(this.chartData[0])); 
        this.ranksNeedsMetricsSourceData = JSON.parse(JSON.stringify(this.baseRankData));
        this.baseRankDataForCompetitors = {};
        let otherData = this.baseRankData["otherData"];
        if (typeof otherData["moneyballStickResults"] !== "undefined") {
          this.moneyballStickRankData = otherData["moneyballStickResults"];
          let titleSuffix = otherData["titleSuffix"];
          this.moneyballStickRankData.titleSuffix = titleSuffix;
        }
        this.isMoneyballStickRank = this.$refs.chartCriteria.$data.displayType == "moat-rank";
        this.updateRanksNeedsMetricsOptions();
        if (this.chartData.length > 1) {
          let moatRankData = JSON.parse(JSON.stringify(this.chartData[1])); 
          let otherDataForMoatRankData = moatRankData["otherData"] || {};
          this.vAxisForPerformance = typeof otherDataForMoatRankData["vAxisForPerformance"] != "undefined" && otherDataForMoatRankData["vAxisForPerformance"] != null ? JSON.parse(JSON.stringify(otherDataForMoatRankData["vAxisForPerformance"])) : [];
          this.vAxisForMetric = typeof otherDataForMoatRankData["vAxisForMetric"] != "undefined" && otherDataForMoatRankData["vAxisForMetric"] != null ? JSON.parse(JSON.stringify(otherDataForMoatRankData["vAxisForMetric"])) : [];
        }        
        if (this.isMoneyballStickRank == true) {
          if (this.chartData.length > 2) {
            this.baseRankDataForCompetitors = JSON.parse(JSON.stringify(this.chartData[2])); 
          }           
          let moatRankData = JSON.parse(JSON.stringify(this.chartData[1])); 
          this.setChartResults(moatRankData.companyList);
        }
        setTimeout(() => {
          if (typeof this.$refs.ranksNeedsMetricsCriteria != "undefined") {
            // make sure the.saveClientChartObject.criteria is set before loading the criteria data into the criteria component
            if(typeof this.saveClientChartObject != "undefined" && typeof this.saveClientChartObject.criteria != "undefined" && this.saveClientChartObject.criteria != "") {
              let criteriaCopy = new URLSearchParams(this.saveClientChartObject.criteria);
              this.$refs.ranksNeedsMetricsCriteria.loadCriteriaData(criteriaCopy);
            }
//            this.$refs.ranksNeedsMetricsCriteria.loadCriteriaData(this.clientChart.criteria);
          }
        }, 1000);
      } catch (err) {
        ErrorService.processException("Ranks.displayChartCallback", err, "chart", this);
      }
    }
  },
  umnounted() { },
  computed: {},
  mounted() {
    let savedCriteria = typeof this.clientChart.criteria == "string"
      ? new URLSearchParams(this.clientChart.criteria)
      : new URLSearchParams();
    if (!savedCriteria.has("displayNumberOfResponses")) {
      this.eChartCriteria.displayNumberOfResponses = true;
      if (this.$refs.chartCriteria) {
        this.$refs.chartCriteria.eChartCriteria.displayNumberOfResponses = true;
      }
    }
  },
  created() {
    this.chart = ChartService.getChartAttributes("Ranks");
  },
  props: {},
  watch: {}
};
</script>
